module.exports = __webpack_public_path__ + "static/media/background-fog-a.ae53449a.png";